module.exports = __webpack_public_path__ + "lato-thin-13fa4c60e0ee7ea5fe2bd84059fb8cac.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-thin/lato-thin.woff
// module id = 1039
// module chunks = 0